import { useMemo } from 'react';
import { PipelineStatus, PipelineSummaryStats } from '../../const/PipelineTypes';
import styles from './Summary.module.css';

interface PipelineSummaryProps {
  pipelineData: PipelineSummaryStats;
  className?: string;
  id?: string;
}

interface StatusItem {
  label: string;
  value: number;
  status: PipelineStatus;
  iconClass: string;
}

const PipelineSummary = ({ className, pipelineData }: PipelineSummaryProps) => {
  const { isLoading, error, stats } = pipelineData;

  const statusItems: StatusItem[] = useMemo(() => {
    return [
      {
        label: 'Successful',
        value: stats[PipelineStatus.Success],
        status: PipelineStatus.Success,
        iconClass: styles.statusIconGreen
      },
      {
        label: 'Failed',
        value: stats[PipelineStatus.Failure],
        status: PipelineStatus.Failure,
        iconClass: styles.statusIconRed
      },
      {
        label: 'Running',
        value: stats[PipelineStatus.InProgress],
        status: PipelineStatus.InProgress,
        iconClass: styles.statusIconBlue
      },
      {
        label: 'Manual',
        value: stats[PipelineStatus.Manual],
        status: PipelineStatus.Manual,
        iconClass: styles.statusIconYellow
      },
      {
        label: 'Warning',
        value: stats[PipelineStatus.Warning],
        status: PipelineStatus.Warning,
        iconClass: styles.statusIconOrange
      },
      {
        label: 'Canceled',
        value: stats[PipelineStatus.Canceled],
        status: PipelineStatus.Canceled,
        iconClass: styles.statusIconGray
      },
      {
        label: 'Aborted',
        value: stats[PipelineStatus.Aborted],
        status: PipelineStatus.Aborted,
        iconClass: styles.statusIconStrongRed
      },
      {
        label: 'Paused',
        value: stats[PipelineStatus.Paused],
        status: PipelineStatus.Paused,
        iconClass: styles.statusIconLightBlue
      }
    ];
  }, [stats]);

  if (isLoading) {
    return (
      <div id="waiting" className="waiting hidden">
        <div className="message"></div>
        <div className="loading"></div>
      </div>
    );
  }

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  return (
    <div className={`${styles.summaryContainer} ${className || ''}`}>
      {statusItems.map((item) => (
        <div key={item.status} className={styles.kpi}>
          {/* <div className={styles.kpiLabel}>Workflows</div> */}
          <div className={styles.kpiValue}>{item.value}</div>
          <div className={styles.kpiStatus}>
            <span className={`${styles.statusIcon} ${item.iconClass}`}></span>
            <span>{item.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PipelineSummary;
